import React from "react"
import PropTypes from "prop-types"
import styles from "./DSTab.module.css"

/**
 * DSTab - A reusable tab component matching the DS design system
 *
 * @param {Array} items - Array of tab items with { key, label } structure
 * @param {string} activeKey - The key of the currently active tab
 * @param {function} onChange - Callback function when tab is changed
 * @param {string} className - Additional CSS classes
 */
const DSTab = ({
  items = [],
  activeKey,
  onChange,
  className = ""
}) => {
  const handleTabClick = (key) => {
    if (key !== activeKey && onChange) {
      onChange(key)
    }
  }

  return (
    <div className={`${styles.dsTab} ${className}`}>
      <div className={styles.dsTabNav}>
        {items.map((item) => (
          <div
            key={item.key}
            className={`${styles.dsTabItem} ${activeKey === item.key ? styles.dsTabItemActive : ""}`}
            onClick={() => handleTabClick(item.key)}
            role="tab"
            aria-selected={activeKey === item.key}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                handleTabClick(item.key)
              }
            }}
          >
            <span className={styles.dsTabLabel}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

DSTab.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default DSTab
